/**
 * Префикс ключей в localStorage.
 *
 * Значение используют оба слоя приложения: AngularJS через
 * `localStorageServiceProvider.setPrefix` (app/config.js) и React через
 * `keyBuilder` (app/core/hooks/useLocalStorage.ts). Под этим префиксом
 * хранится в том числе токен доступа, который axios подставляет в заголовок
 * Authorization, поэтому расхождение значений оставляет все запросы React-слоя
 * без авторизации. Константа вынесена в отдельный модуль без побочных эффектов,
 * чтобы её можно было импортировать из обоих слоёв.
 */
export const LOCAL_STORAGE_PREFIX = 'shbdeployer';
